<div
  class="sectionContainer paddedContent containerMargins"
  style="background-color: #ffffff; max-width: 100%; max-height: 100%"
>
  @if (chartType == 'line') {
    <app-line-chart #theChart [label]="'Monthly Transactions'"></app-line-chart>
  }
  @if (chartType == 'bar') {
    <app-bar-chart #theChart [label]="'Monthly Transactions'"></app-bar-chart>
  }
</div>
